module.exports = __webpack_public_path__ + "static/gtm3_1-6ade7d67341cf5a928433c5a1d15982e.png";